// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2247c071","453":"ae8ae667","732":"9a92153b","977":"8666949d"}[chunkId] + ".chunk.js";
};